import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';

@Component({
  imports: [CommonModule],
  selector: 'app-call-main',
  standalone: true,
  styleUrls: ['./call-main.css'],
  templateUrl: './call-main.html',
})
export class CallMainComponent {
  @Input() isLoading = false;

  @HostBinding('class')
  protected get cssClass() {
    return {
      isLoading: !!this.isLoading,
    };
  }
}
